import styled from 'styled-components';

const IconButton = styled.button`
  cursor: pointer;
  border: 0;
  padding: 0;
  background-color: rgba(0, 0, 0, 0);

  &:focus {
    outline: none;
  }
`;

export default IconButton;
